// extracted by mini-css-extract-plugin
module.exports = {"root":"loaderIndicator_root__3zkh-","rootFullScreen":"loaderIndicator_rootFullScreen__2IEk1 loaderIndicator_root__3zkh-"};